import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { callMsGraph } from '../graph';
import { ProfileData } from './ProfileData';
import Button from 'react-bootstrap/Button';

const Profile = () => {
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);

    // Enhanced styles for a minimal layout
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: '20px',
            paddingTop: '40px',
        },
        card: {
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
            padding: '30px',
            maxWidth: '700px', // Increased from 500px to 700px to fit longer emails
            width: '100%',
            margin: '0 auto',
        },
        heading: {
            fontSize: '1.5rem',
            marginBottom: '10px',
            color: '#333',
        },
        description: {
            fontSize: '0.9rem',
            marginBottom: '20px',
            color: '#666',
        },
        button: {
            marginTop: '10px',
        }
    };

    const RequestProfileData = () => {
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            })
            .then((response) => {
                callMsGraph(response.accessToken).then((response) => setGraphData(response));
            });
    };

    useEffect(() => {
        // Attempt to get profile data when component mounts
        if (accounts[0] && !graphData) {
            RequestProfileData();
        }
    }, [accounts]);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.heading}>Your Profile</h2>
                <p style={styles.description}>Details retrieved from Microsoft Graph API:</p>
                <p style={styles.description}>(this is currently just here for testing)</p>
                
                {graphData ? 
                    <ProfileData graphData={graphData} /> : 
                    <Button 
                        variant="primary" 
                        onClick={RequestProfileData}
                        style={styles.button}
                    >
                        Refresh Profile Information
                    </Button>
                }
            </div>
        </div>
    );
};

export default Profile;